import { TDefinitions } from 'src/parser/DefinitionsCustomization'
import { TAppState } from 'src/redux/createAdminStore'

export const selectDefinitions = (state: TAppState): Partial<TDefinitions> => {
  return state.definitions
}
